import { useState } from "react";
import { MdAdd } from "react-icons/md";
import NewRepairOrder from "./NewRepairOrder";
import "./RepairOrder.scss";

export default function RepairOrder() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="sales-layout__page repair-order">
      <header className="repair-order__header-top">
        <div className="repair-order__title-group">
          <h1>Reparaturauftrag</h1>
          <p>0 von 0 Reparaturaufträgen</p>
        </div>
        <div className="repair-order__actions">
          <button
            className="repair-order__btn-action repair-order__btn-action--primary"
            onClick={() => setIsModalOpen(true)}
          >
            <MdAdd /> Neuer Reparaturauftrag
          </button>
        </div>
      </header>

      {isModalOpen && <NewRepairOrder onClose={() => setIsModalOpen(false)} />}
    </section>
  );
}
